export default __webpack_public_path__ + "static/media/partner-18.c9727cc3.png";